import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-7" }
const _hoisted_2 = {
  key: 0,
  class: "col-5"
}
const _hoisted_3 = {
  key: 1,
  class: "col-5"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = ["disabled", "onClick"]

import { ErrorMessage, FieldArray } from 'vee-validate'
import TextField from '@/components/CommonUI/TextField.vue'
import IconUI from '@/components/CommonUI/IconUI.vue'
import { emptyAlternativeTitle, maxWorkTitlesCount } from '@/constants'
import NotificationUI from '@/components/CommonUI/NotificationUI.vue'
import { useGettext } from 'vue3-gettext'


export default /*#__PURE__*/_defineComponent({
  __name: 'AlternativeTitles',
  setup(__props) {

const { $gettext } = useGettext()

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(_unref(FieldArray), { name: "alternative_titles" }, {
    default: _withCtx(({
      fields, push, remove,
    }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (entry, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: entry.key,
          class: _normalizeClass(["row items-center", { 'no-space': index !== fields.length - 1 }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TextField, {
              name: `alternative_titles[${index}].name`,
              label: _unref($gettext)('Alternative Title'),
              "tooltip-info-text": _unref($gettext)('In order to make identification of your Musical Work easier for collection societies, please provide any potential variations of the main title. Alternative Titles are optional but, for example, if the Work\'s main title is ‘1 love 4 U’, please add the alternative titles, ‘One Love For U’ and ‘One Love For You’. Alternative Titles can also be added to claim different versions of the same Musical Work under a single registration. This should only be applied if the same contributors are credited and their share allocation remains the same on each version. For example, remixes or instrumentals of the original Musical Work can be claimed via a single registration'),
              "hide-label": index !== 0,
              optional: ""
            }, null, 8, ["name", "label", "tooltip-info-text", "hide-label"])
          ]),
          (index === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(TextField, {
                  name: "duration",
                  label: _unref($gettext)('Duration'),
                  class: "duration-input"
                }, null, 8, ["label"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(IconUI, {
                  class: "delete-button",
                  name: "rubbish-bin",
                  fill: "body",
                  "data-testid": `remove-title${index}`,
                  onClick: ($event: any) => (remove(index))
                }, null, 8, ["data-testid", "onClick"])
              ]))
        ], 2))
      }), 128)),
      _createVNode(_unref(ErrorMessage), { name: "alternative_titles" }, {
        default: _withCtx(({ message }) => [
          _createVNode(NotificationUI, {
            class: "col-10",
            message: message,
            type: "error outline",
            "icon-fill": "error",
            "icon-name": "danger"
          }, null, 8, ["message"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "button text-button action-button",
          disabled: fields.length === _unref(maxWorkTitlesCount),
          onClick: ($event: any) => (push(_unref(emptyAlternativeTitle)))
        }, [
          _createVNode(IconUI, { name: "plus-circle" }),
          _withDirectives((_openBlock(), _createElementBlock("span", null, [
            _createTextVNode("Add another title")
          ])), [
            [_directive_translate]
          ])
        ], 8, _hoisted_5)
      ])
    ]),
    _: 1
  }))
}
}

})